import { connect } from 'react-redux';

import CollectionFilterOverview from 'components/CollectionFilterOverview';
import * as actions from 'state/actions';
import CollectionPage from 'state/selectors/collection-page';

const mapStateToProps = (state, { ...ownProps }) => {
  const filterOptions = CollectionPage.getAppliedFilterOptions(state);

  return {
    filterOptions,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  setCollectionPageFilter: ({ option, value, filterIdentifier }) =>
    dispatch(actions.setCollectionPageFilter({ option, value, filterIdentifier })),
  clearCollectionFilters: () => dispatch(actions.clearCollectionPageFilters()),
});

const mergeProps = (stateProps, dispatchProps) => ({
  clearCollectionFilter: ({ option, filterIdentifier }) =>
    dispatchProps.setCollectionPageFilter({
      option,
      value: false,
      filterIdentifier,
    }),
  ...stateProps,
  ...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CollectionFilterOverview);
